// src/router/categoria-contrato.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['triveni_contratos']

const categoriaContratoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Categorias de Contrato',
    to: 'CategoriasContrato'
  }
]

export default [
  {
    path: '/categorias-contrato',
    name: 'CategoriasContrato',
    component: () => import('@/views/CategoriaContrato/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Categorias de Contrato',
      breadcrumb: categoriaContratoBreadCrumb
    }
  },
  {
    path: '/categorias-contrato/novo',
    name: 'CategoriaContratoNovo',
    component: () => import('@/views/CategoriaContrato/NovoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Nova Categoria de Contrato',
      breadcrumb: [
        ...categoriaContratoBreadCrumb,
        {
          label: 'Nova Categoria de Contrato',
          to: 'CategoriaContratoNovo'
        }
      ]
    }
  },
  {
    path: '/categorias-contrato/:id/edit',
    name: 'CategoriaContratoEdit',
    component: () => import('@/views/CategoriaContrato/NovoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes da Categoria de Contrato',
      breadcrumb: [
        ...categoriaContratoBreadCrumb,
        {
          label: 'Detalhes da Categoria de Contrato',
          to: 'CategoriaContratoEdit'
        }
      ]
    }
  }
]
